import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleImageViewerComponent } from './single-image-viewer.component';
import { GlobalModulesModule } from '../../global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [SingleImageViewerComponent],
  exports: [SingleImageViewerComponent],
  entryComponents: [
    SingleImageViewerComponent
  ]
})
export class SingleImageViewerModule { }
